import { render } from "./noticeManagement.vue?vue&type=template&id=6c4eda1b&scoped=true"
import script from "./noticeManagement.vue?vue&type=script&lang=js"
export * from "./noticeManagement.vue?vue&type=script&lang=js"

import "./noticeManagement.vue?vue&type=style&index=0&id=6c4eda1b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4eda1b"]])

export default __exports__